import { render, staticRenderFns } from "./ScarfInfo.vue?vue&type=template&id=1c6d2982&scoped=true&"
import script from "./ScarfInfo.vue?vue&type=script&lang=ts&"
export * from "./ScarfInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ScarfInfo.vue?vue&type=style&index=0&id=1c6d2982&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d2982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
